var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('StatusChip',{attrs:{"data-tourid":"finding-status-chip","status":_vm.status,"statusText":_vm.statusText,"availableStatus":_vm.availableStatus,"isEditable":_vm.canEdit,"large":_vm.large,"textClass":_vm.textClass,"color":_vm.color},on:{"onChange":_vm.handleSelectStatus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }